import { useCallback, useState } from 'react';
import Envelope from '@/assets/icons/Envelope.svg';
import { Form } from '@/components/Form';
import { CloseXButton, Modal } from '@/components/Modal';
import { TextField } from '@/components/TextField';
import { Button } from '@/components/Button';
import type { Handler } from '@/types';
import { EMAIL_REGEX } from '@/constants';
import { useNotifyMe } from './useNotifyMe';



const validateEmail = (value: string) =>
  value && !EMAIL_REGEX.test(value)
    ? 'Please enter a valid email address.'
    : '';

interface NotifyModalProps {
  sku: string | null;
  isCarouselCta?: boolean;
  productName: string | null;
}

export const NotifyModal = ({
  sku,
  isCarouselCta = false,
  productName,
}: NotifyModalProps) => {
  const { isPending, notify } = useNotifyMe();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  const handleSubmit = useCallback(
    (close: () => void): Handler =>
      e => {
        e.preventDefault();

        if (!isPending) {
          notify({ sku, email, name }, { onSuccess: close });
        }
      },
    [sku, email, isPending, name, notify],
  );

  return sku && productName ? (
    <Modal
      isCarouselCta={isCarouselCta}
      trigger={{
        content: 'Notify me',
        icon: <Envelope />,
        label: `Notify me when ${productName} is back in stock.`,
      }}
    >
      {({ close }) => (
        <>
          <p>
            Leave your contact details and we&apos;ll send you an email as soon
            as the product comes back into stock.
          </p>
          <Form handleSubmit={handleSubmit(close)}>
            <TextField
              isRequired
              label="Name"
              name="name"
              onChange={setName}
              value={name}
            />
            <TextField
              isRequired
              label="Email"
              name="email"
              onChange={setEmail}
              type="email"
              validate={validateEmail}
              value={email}
            />
            <Button isPending={isPending} type="submit">
              Notify me
            </Button>
            <CloseXButton className="close-modal" slot="close" />
          </Form>
        </>
      )}
    </Modal>
  ) : null;
};
